/**
 * Tipos de exceção usados na aplicação.
 * Use estas classes ao lançar erros em serviços e use cases.
 */

export class AppException extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public readonly cause?: unknown
  ) {
    super(message);
    this.name = 'AppException';
    Object.setPrototypeOf(this, AppException.prototype);
  }
}

/** Erros de autenticação (Firebase Auth, credenciais, etc.). */
export class AuthException extends AppException {
  constructor(code: string, message: string, cause?: unknown) {
    super(code, message, cause);
    this.name = 'AuthException';
    Object.setPrototypeOf(this, AuthException.prototype);
  }
}

/** Erros de validação (campos inválidos, regras de negócio). */
export class ValidationException extends AppException {
  constructor(code: string, message: string, cause?: unknown) {
    super(code, message, cause);
    this.name = 'ValidationException';
    Object.setPrototypeOf(this, ValidationException.prototype);
  }
}

/** Recurso ou entidade não encontrada. */
export class NotFoundException extends AppException {
  constructor(code: string, message: string, cause?: unknown) {
    super(code, message, cause);
    this.name = 'NotFoundException';
    Object.setPrototypeOf(this, NotFoundException.prototype);
  }
}

/** Erros de rede ou falha externa (API, timeout). */
export class NetworkException extends AppException {
  constructor(code: string, message: string, cause?: unknown) {
    super(code, message, cause);
    this.name = 'NetworkException';
    Object.setPrototypeOf(this, NetworkException.prototype);
  }
}
